
import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import OrderListCommon from "@/components/order/order/OrderListCommon.vue";
import CommunityNav from "@/components/community/widget/CommunityNav.vue";

@Component({
  name: 'CommunityOrders',
  components: {
    OrderListCommon,
    CommunityNav,
  }
})
export default class CommunityOrders extends Vue {
  @Prop()
  protected communityId!: number;
}

